var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTypeBsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 109,
    viewBox: "0 0 125 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.9497,
    y: 16.5898,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9796 70.2641H41.267C40.8819 70.2641 40.5125 70.111 40.2402 69.8386C39.9679 69.5664 39.8149 69.1969 39.8149 68.8119V62.243L34.8088 59.9504C34.478 59.7847 34.223 59.4988 34.0958 59.1514C33.9686 58.804 33.9789 58.421 34.1245 58.0809L38.3628 49.9347C38.3628 47.4594 38.9955 45.0254 40.2008 42.8634C40.8174 41.7576 41.5733 40.7417 42.4465 39.839M63.0484 73.1683L61.5964 61.5515C63.5766 60.0663 65.1441 58.0997 66.1504 55.8383C67.1567 53.5769 67.5683 51.0958 67.3462 48.6306C67.1238 46.1654 66.275 43.7979 64.8805 41.753C64.2284 40.7971 63.4675 39.9265 62.6156 39.1572",
    stroke: "#9BBAC1",
    strokeWidth: 3.16627,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4961 44.2646H55.7194",
    stroke: "#E3DFE9",
    strokeWidth: 3.16627,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9805 37.3417C48.2408 36.7638 47.6416 36.0257 47.2279 35.183C46.8143 34.3402 46.597 33.4147 46.5924 32.4759C46.5737 29.1029 49.2934 26.2954 52.6655 26.2176C53.9724 26.186 55.2562 26.5667 56.3345 27.3057C57.4127 28.0448 58.231 29.1046 58.6731 30.3349C59.115 31.5652 59.1583 32.9034 58.797 34.1598C58.4354 35.4161 57.6875 36.5267 56.6593 37.334C56.4325 37.5098 56.2488 37.735 56.1218 37.9924C55.995 38.2499 55.9284 38.5328 55.9273 38.8198V39.2865C55.9273 39.4516 55.8618 39.6099 55.745 39.7266C55.6284 39.8433 55.4699 39.9089 55.3049 39.9089H50.3263C50.1614 39.9089 50.003 39.8433 49.8864 39.7266C49.7695 39.6099 49.704 39.4516 49.704 39.2865V38.8198C49.7038 38.5346 49.6383 38.2533 49.5131 37.9972C49.3876 37.7411 49.2055 37.5169 48.9805 37.3417Z",
    fill: "#E3DFE9",
    stroke: "#E3DFE9",
    strokeWidth: 3.16627,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 35.6123,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 28.4785,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 50.6719,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 43.5381,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 66.5244,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2993,
    y: 59.3906,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23047 57.7313L76.6078 18.4443L8.23047 57.7313Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.698 33.9587L116.027 30.8564L110.698 33.9587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7275 88.2682L55.0566 85.166",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.261 77.295C114.093 77.3819 114.697 78.1276 114.61 78.9593C114.524 79.791 113.778 80.3958 112.946 80.3089C112.114 80.2221 111.51 79.4763 111.597 78.6446C111.683 77.813 112.429 77.2082 113.261 77.295Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6202 94.7314C32.9878 94.8742 33.9823 96.1005 33.8395 97.4682C33.6967 98.8358 32.4703 99.8303 31.1027 99.6875C29.735 99.5447 28.7406 98.3184 28.8834 96.9507C29.0262 95.5831 30.2525 94.5886 31.6202 94.7314Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.751 6.72651C61.1187 6.8693 62.1132 8.09566 61.9704 9.46331C61.8276 10.831 60.6012 11.8254 59.2336 11.6826C57.8659 11.5399 56.8714 10.3135 57.0142 8.94584C57.157 7.5782 58.3834 6.58371 59.751 6.72651Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06599 38.498C2.6942 38.498 3.20425 39.0081 3.20425 39.6363C3.20425 40.2645 2.6942 40.7746 2.06599 40.7746C1.43779 40.7746 0.927734 40.2645 0.927734 39.6363C0.927734 39.0081 1.43779 38.498 2.06599 38.498Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.617 30.9971C123.245 30.9971 123.755 31.5071 123.755 32.1353C123.755 32.7635 123.245 33.2736 122.617 33.2736C121.989 33.2736 121.479 32.7635 121.479 32.1353C121.479 31.5071 121.989 30.9971 122.617 30.9971Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.459 5.7002L104.758 1.32015",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 2.8916L106.372 4.19102",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68115 80.2822L7.82039 75.8578",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11182 77.5293L9.53623 78.6685",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.65 100.048L102.541 95.5669",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9297 97.3857L104.411 98.2768",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeBsImg);
export default __webpack_public_path__ + "static/media/question_type_bs_img.5ed80a07ce273bbafdc9708ad637a372.svg";
export { ForwardRef as ReactComponent };